/**
 * Maintenance Mode Configuration Utility
 * Centralized configuration for website maintenance mode
 */

// Get maintenance mode from environment variable
const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

// Admin bypass roles (can be extended for future role-based access)
const ADMIN_ROLES = ['admin', 'super_admin', 'maintenance_admin'];

/**
 * Check if maintenance mode is enabled
 * @returns {boolean} True if maintenance mode is enabled
 */
export const isMaintenanceMode = () => {
  return MAINTENANCE_MODE;
};

/**
 * Check if current user has admin privileges for maintenance bypass
 * @param {string|Array} userRole - User role(s) to check
 * @returns {boolean} True if user has admin privileges
 */
export const isAdminUser = (userRole) => {
  if (!userRole) return false;
  
  const roles = Array.isArray(userRole) ? userRole : [userRole];
  return roles.some(role => ADMIN_ROLES.includes(role));
};

/**
 * Check if maintenance mode should be shown to current user
 * @param {string|Array} userRole - Optional user role(s) for admin bypass
 * @returns {boolean} True if maintenance page should be shown
 */
export const shouldShowMaintenance = (userRole = null) => {
  // If maintenance mode is disabled, never show maintenance page
  if (!isMaintenanceMode()) return false;
  
  // If user has admin privileges, allow bypass
  if (isAdminUser(userRole)) return false;
  
  // Otherwise, show maintenance page
  return true;
};

/**
 * Get maintenance mode configuration
 * @returns {Object} Maintenance configuration object
 */
export const getMaintenanceConfig = () => {
  return {
    enabled: MAINTENANCE_MODE,
    adminRoles: ADMIN_ROLES,
    estimatedRecoveryTime: '2-3 hours',
    supportEmail: 'support@chefrepublic.us',
    companyName: 'Chef Republic',
    logoUrl: '/logo.svg'
  };
};

export default {
  isMaintenanceMode,
  isAdminUser,
  shouldShowMaintenance,
  getMaintenanceConfig
};
